import { createContext, createElement, useCallback, useContext, useEffect, useRef, useState } from "react";
import { API } from "@/lib/site";

const ApkContext = createContext(null);

export function ApkProvider({ children }) {
  const [state, setState] = useState({ apk: null, loading: true, error: null });
  const reqId = useRef(0);
  const lastCall = useRef(0);

  const refetch = useCallback(async (force = false) => {
    const now = Date.now();
    if (!force && now - lastCall.current < 500) return;
    lastCall.current = now;
    const id = ++reqId.current;
    try {
      const res = await fetch(`${API}/apk/latest?t=${now}`, {
        cache: "no-store",
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (id !== reqId.current) return;
      setState({ apk: data.apk, loading: false, error: null });
    } catch (e) {
      if (id !== reqId.current) return;
      setState((s) => ({ ...s, loading: false, error: e.message }));
    }
  }, []);

  useEffect(() => {
    refetch(true);
    const onFocus = () => refetch();
    const onVis = () => document.visibilityState === "visible" && refetch();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    const poll = setInterval(() => document.visibilityState === "visible" && refetch(), 60000);
    return () => {
      clearInterval(poll);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [refetch]);

  return createElement(ApkContext.Provider, { value: { ...state, refetch } }, children);
}

export default function useLatestApk() {
  return useContext(ApkContext);
}
